import { Component } from '@angular/core';

@Component({
  selector: 'app-coverage',
  standalone: true,
  imports: [],
  templateUrl: './coverage.component.html',
  styleUrl: './coverage.component.scss'
})
export class CoverageComponent {

}
